import * as React from 'react';
import { Link } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { ColapsePanel } from '../core/ColapsePanel';
import { BookingData, CMS, CommonCommunicationData, SecurityData } from '../shared/index';
import { CoreComponentAjaxUtils, getAjaxhelper, isNull } from '../utils/index';
export interface MyReviewProps extends BaseComponentProps {
  lang: string;
  user: SecurityData.ApplicationUser;
  user_login: boolean;
}
export interface MyReviewState extends BaseComponentState {
  count: number;
  reviews: CMS.Review[];
  page: number;
  total: number;
  requesting: boolean;
  errorMessage: string;
  version: number;
}

export class MyReview extends BaseComponent<MyReviewProps, MyReviewState> {

  static FIELD_COMPARED_PROPS: string[] = ['lang', 'user', 'user_login'];
  /**
   * field yang di compare pada state untuk di check ada perubahan atau tidak
   */
  static FIELD_COMPARED_STATE: string[] = ['version'];

  constructor(props: MyReviewProps) {
    super(props);
    this.state = {
      count: 15,
      reviews: [],
      page: 0,
      total: 0,
      requesting: true,
      errorMessage: '',
      version: 0
    };
  }

  shouldComponentUpdate(nextProps: MyReviewProps, nextState: MyReviewState): boolean {
    if (this.compareForShouldComponentUpdateStateOrProp(MyReview.FIELD_COMPARED_PROPS, this.props, nextProps)) {
      return true;
    }
    if (this.compareForShouldComponentUpdateStateOrProp(MyReview.FIELD_COMPARED_STATE, this.state, nextState)) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    this.getReview();
  }

  componentDidUpdate(prevProps: MyReviewProps, prevState: MyReviewState) {
    if (prevProps.user !== this.props.user) {
      this.getReview();
    }
  }

  getReview: () => any = () => {
    let incModel: CommonCommunicationData.IncludeModelParam[] = [{
      modelName: 'CmsSlug'
    }];
    new CoreComponentAjaxUtils(getAjaxhelper()).getPagedDataWithPromise({
      modelName: 'Review',
      pageSize: this.state.count,
      page: this.state.page,
      orders: [['createdAt', 'desc']],
      where: {
        custId: this.props.user.userId
      },
      eraseAuditTrail: true,
      includeModels: incModel
    }).then(
      d => {
        this.setStateHelper(
          st => {
            let datas: BookingData.BookingHeader[] = d.rows as any;
            if (!isNull(datas)) {
              st.reviews = datas;
              st.total = d.count!;
            }
          },
          () => {
            let indexReview: { [id: number]: any } = {};
            for (let review of this.state.reviews) {
              if (isNull(indexReview[review.id!])) {
                indexReview[review.id!] = {};
              }
              indexReview[review.id!] = review;
            }
            for (let review of this.state.reviews) {
              let model = review.CmsSlug!.model;
              let id = JSON.parse(review.CmsSlug!.data!).id;
              let revId = review.id;
              if (model === 'CmsBlog') {
                getAjaxhelper().get(`/dynamics/rest-api/generic/${model}/${id}`).then(
                  (e: any) => {
                    let data = indexReview[revId!];
                    data.cmsDetail = e;
                    this.setStateHelper(st => {
                      st.version++;
                    });
                  }).catch((exc) => {
                    console.error('error: ', exc);
                    this.setState({ errorMessage: exc.message, requesting: false });
                  });
              }
              if (model === 'Hotel') {
                new CoreComponentAjaxUtils(getAjaxhelper()).getPagedDataWithPromise({
                  modelName: 'HotelImage',
                  pageSize: this.state.count,
                  page: this.state.page,
                  orders: [['order', 'asc']],
                  where: {
                    hotelCode: id
                  },
                  eraseAuditTrail: true,
                  includeModels: incModel
                }).then(
                  f => {
                    let data = indexReview[revId!];
                    data.cmsDetail = f.rows![0];
                    this.setStateHelper(st => {
                      st.version++;
                    });
                  }).catch((exc) => { console.error('error: ', exc); });
              }
            }
          }
        );
      }).catch((exc) => { console.error('error: ', exc); });
  }

  render() {
    if (this.state.haveReactError) {
      return this.renderErrorPanel();
    }
    let isiTablenews = [];
    if (!isNull(this.state.reviews) && this.state.reviews.length > 0) {
      for (let review of this.state.reviews) {
        if (review.CmsSlug!.model === 'CmsBlog') {
          let imgsrc = !isNull(review.cmsDetail) && !isNull(review.cmsDetail.thumbUrl) ? review.cmsDetail.thumbUrl : '';
          isiTablenews.push(
            <tr>
              <td style={{ width: '20%' }}>
                <Link to={`/${review.page}`} target='_blank'>
                  <p>{review.CmsSlug!.title} </p>
                  <img src={`${imgsrc}`} width='250' />
                </Link>
              </td>
              <td style={{ verticalAlign: 'top' }}>
                <h4>{review.subject}</h4>
                <p>
                  {review.message}
                </p>
              </td>
            </tr>
          );
        }

      }
    }
    let isiTableHotel = [];
    if (!isNull(this.state.reviews) && this.state.reviews.length > 0) {
      for (let review of this.state.reviews) {
        if (review.CmsSlug!.model === 'Hotel') {
          let imgsrc = !isNull(review.cmsDetail) && !isNull(review.cmsDetail.path) ? review.cmsDetail.path : '';
          isiTableHotel.push(
            <tr>
              <td style={{ width: '20%' }}>
                <Link to={`/${review.page}`} target='_blank'>
                  <p>{review.CmsSlug!.title} </p>
                  <img src={`https://photos.hotelbeds.com/giata/${imgsrc}`} width='250' />
                </Link>
              </td>
              <td style={{ verticalAlign: 'top' }}>
                <h4>{review.subject}</h4>
                <p>
                  {review.message}
                </p>
              </td>
            </tr>
          );
        }

      }
    }
    let nReview = (
      <table className="table">
        <thead>
          <tr>
            <th>Page</th>
            <th>Review</th>
          </tr>
        </thead>
        <tbody>
          {isiTablenews}
        </tbody>
      </table>
    );
    let htReview = (
      <table className="table">
        <thead>
          <tr>
            <th>Page</th>
            <th>Review</th>
          </tr>
        </thead>
        <tbody>
          {isiTableHotel}
        </tbody>
      </table>
    );
    return (
      <div className=" " style={{ minHeight: 500 }}>
        <h1>My Review</h1>
        <ColapsePanel key='detail' title="Hotel Reviews" component={htReview} colapse={true} />
        <ColapsePanel key='detail' title="News Reviews" component={nReview} colapse={true} />
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/my-account/MyReview.tsx